export const ERROR_MESSAGES = {
  NO_COMPILEROPTIONS: 'Invalid `compilerOptions`: the value must be an object!',
  NO_BASEURL: 'Invalid `compilerOptions.baseUrl`: the value must be a string!',
  NO_PATHS: 'Invalid `compilerOptions.paths`: the value must be an object!'
}
